import BaseModel from '../../../../../base';
import { TOURNAMENT_DOP_SCORE_MAX } from '../../dop-score/constants';

export default class TournamentStageGroupUserScore extends BaseModel {
  constructor(score = {}, url = '') {
    super(score, url);

    this.tournament_stage_group_dop_score_item_id = score.tournament_stage_group_dop_score_item_id;
    this.tournament_stage_group_user_assignment_id = score.tournament_stage_group_user_assignment_id;
    this.score = Number(score.score || 0);
    this.created_at = score.created_at;
  }

  static toValues(scores = [], items = [], fallbackTotal = 0) {
    const currentScores = items.length
      ? scores.filter((score) => items.some(({ id }) => (
        String(id) === String(score.tournament_stage_group_dop_score_item_id)
      )))
      : scores;
    const values = currentScores.reduce((result, score) => ({
      ...result,
      [score.tournament_stage_group_dop_score_item_id]: Number(score.score || 0),
    }), {});
    return items.reduce((result, { id }, index) => ({
      ...result,
      [id]: values[id] ?? (!currentScores.length && !index ? Number(fallbackTotal || 0) : 0),
    }), items.length ? {} : values);
  }

  static hasCurrentScores(scores = [], items = []) {
    return scores.some((score) => items.some(({ id }) => (
      String(id) === String(score.tournament_stage_group_dop_score_item_id)
    )));
  }

  static getTotal(values = {}, items = []) {
    return items.reduce(
      (total, item) => total + Number(values[item.id] || 0),
      0,
    );
  }

  static getResult(values = {}, model) {
    const total = this.getTotal(values, model?.scoreItems);
    if (!model?.convert_to_100_scale) return Number(total.toFixed(model?.decimal_places ?? 2));
    const maximum = model.scoreItems.reduce((sum, item) => sum + Number(item.max_score || 0), 0);
    const result = maximum ? (total / maximum) * 100 : total;
    return Number(result.toFixed(model.decimal_places));
  }

  static isInvalid(values = {}, items = []) {
    const scores = items.map(({ id, max_score }) => ({
      value: Number(values[id] || 0),
      max: max_score == null ? TOURNAMENT_DOP_SCORE_MAX : Number(max_score),
    }));
    return scores.some(({ value, max }) => !Number.isFinite(value) || value < 0 || value > max)
      || scores.reduce((total, { value }) => total + value, 0) > TOURNAMENT_DOP_SCORE_MAX;
  }

  static bulkPayload(values = {}, items = [], assignmentId) {
    return items.map(({ id }) => ({
      tournament_stage_group_dop_score_item_id: id,
      tournament_stage_group_user_assignment_id: assignmentId,
      score: Number(values[id] || 0),
    }));
  }
}
